import {queryOptions} from '@tanstack/react-query';

import type {MembersListParams} from 'api/v2';
import {membersList, membersRetrieve} from 'api/v2';

export const membersQueryKeys = {
  all: () => ['member'],
  detail: (id: string) => [...membersQueryKeys.all(), 'detail', id],
  lists: () => [...membersQueryKeys.all(), 'list'],
  list: (params: MembersListParams) => [...membersQueryKeys.lists(), params],
};

const membersAll = (params: MembersListParams) =>
  queryOptions({
    queryKey: membersQueryKeys.list(params),
    queryFn: () => membersList(params),
    select: (data) => data.data,
  });

const membersDetail = (id: string) =>
  queryOptions({
    queryKey: membersQueryKeys.detail(id),
    queryFn: () => membersRetrieve(id),
    select: (data) => data.data,
  });

export const membersQueryOptions = {
  list: membersAll,
  detail: membersDetail,
};
